import { render } from "./sub-menu-item.html?vue&type=template&id=17f46aa6&scoped=true&ts=true"
import script from "./sub-menu-item.ts?vue&type=script&lang=ts"
export * from "./sub-menu-item.ts?vue&type=script&lang=ts"

import "./sub-menu-item.scss?vue&type=style&index=0&id=17f46aa6&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f46aa6"]])

export default __exports__